export default "__VITE_ASSET__ky87algJ__"